module.exports = __webpack_public_path__ + "img/facebook.e1065fb5.png";